import { mapState } from "vuex";
export default {
  name: "Index",
  computed: { ...mapState(["news"])
  }
};